<card name="Store actions table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="key" let-item>
        <td>
          {{ item.key }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="id" let-item>
        <td>
          {{ item.id }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="updatedAt" let-item>
        <td>
          {{ item.updatedAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="product" let-item>
        <td>
          {{ item.product }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="active" let-item>
        <td>
          <badge-exist existText="Active" [item]="item.active"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="platform" let-item>
        <td>
          {{ item.platform }}
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
